export const ICONS = {
  CHECK: "/icons/check.png",
  COIN: "/icons/coin.png",
  CONE: "/icons/cone.png",
  EMAIL: "/icons/email.png",
  ENVELOPE: "/icons/envelope.png",
  HEALTH: "/icons/health.png",
  HEART: "/icons/heart.png",
  MEDICINE: "/icons/medicine.png",
  NOTES: "/icons/notes.png",
  SMS: "/icons/sms.png",
  WSP: "/icons/wsp.png",
  CROSS: "/icons/cross.png",
  NO_RESULTS: "/icons/no-results.png",
  RED_ALERT: "/icons/red_alert.png",
};

export const LOGOS = {
  BICE_VIDA: "/logos/bicevida.svg",
  FAVICON: "/logos/favicon.png",
  GOOGLE_PLAY: "/logos/download-google-play.png",
  APP_STORE: "/logos/download-app-store.svg",
};
